import { Fragment, h } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/compat';

import './FactPopup.scss';

const FactPopup = ({ factText, factTitle, children }) => {
    const [showFacts, setShowFacts] = useState(false);

    useEffect(() => {
        const factsPopup = document.querySelector('.facts-popup');
        const factsPopupButton = document.querySelector('.facts-quote');

        const handleClickOutside = event => {
            if (
                factsPopup &&
                !factsPopup.contains(event.target) &&
                !factsPopupButton.contains(event.target)
            ) {
                event.stopPropagation();
                setShowFacts(false);
            }
        };

        const handleEscape = event => {
            event.stopPropagation();
            if (event.keyCode === 27) {
                setShowFacts(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    return (
        <>
            {' '}
            <span className="facts-quote">
                <span onClick={() => setShowFacts(!showFacts)}>
                    {children} <span className="material-symbols-outlined icon">info</span>
                </span>
                <div className={`facts-popup ${showFacts ? 'show-facts' : ''}`}>
                    <span
                        className="material-symbols-outlined icon"
                        onClick={e => {
                            e.stopPropagation();
                            setShowFacts(false);
                        }}
                    >
                        close
                    </span>
                    {factTitle && <h4 className="facts-popup-title">{factTitle}</h4>}
                    {factText && <p className="facts-popup-text">{factText}</p>}
                </div>
            </span>{' '}
        </>
    );
};

export default FactPopup;
